/* Haldrow golf glove — selector de packs, añadir al carrito con regalos, carrito lateral (sustituye a Kaching de la ref) */
(function () {
  var D = window.GGDATA || {};
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function qtyInput() { return $('input[name="quantity"][form^="product-form-"]') || $('#product-form-gg__main input[name="quantity"]'); }

  /* ---------- packs ---------- */
  function pick(bar) {
    $$('.gg-kb .kaching-bundles__bar').forEach(function (b) {
      var on = b === bar; b.classList.toggle('kaching-bundles__bar--selected', on);
      var r = b.querySelector('input[type=radio]'); if (r) r.checked = on;
    });
    var q = qtyInput(); if (q) q.value = bar.getAttribute('data-gg-qty') || 1;
  }
  function selectedQty() { var b = $('.gg-kb .kaching-bundles__bar--selected'); return b ? +b.getAttribute('data-gg-qty') : 1; }
  document.addEventListener('click', function (e) {
    var bar = e.target.closest && e.target.closest('.gg-kb .kaching-bundles__bar');
    if (bar) { e.preventDefault(); pick(bar); }
  });
  function initBars() { var s = $('.gg-kb .kaching-bundles__bar--selected') || $('.gg-kb .kaching-bundles__bar'); if (s) pick(s); }

  /* ---------- la app Kaching de Haldrow no debe colarse aquí ---------- */
  function cleanKaching() {
    $$('#MainContent kaching-bundles-block, #MainContent kaching-bundle').forEach(function (e) { e.remove(); });
    $$('form[action*="/cart/add"] [name^="properties[__kaching"]').forEach(function (e) { e.remove(); });
  }
  new MutationObserver(cleanKaching).observe(document.documentElement, { childList: true, subtree: true });

  /* ---------- añadir al carrito ---------- */
  function giftsFor(q) {
    var g = D.gifts || {}, out = [];
    if (q >= 3 && g.ship) out.push(g.ship);
    if (q >= 3 && g.guide) out.push(g.guide);
    if (q >= 5 && g.card) out.push(g.card);
    return out;
  }
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f.matches || !f.matches('#product-form-gg__main')) return;
    e.preventDefault(); e.stopImmediatePropagation(); cleanKaching();
    var btn = f.querySelector('[name=add]'); if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }
    var id = +f.querySelector('input[name=id]').value, q = selectedQty();
    var props = {}; var ini = f.querySelector('input[name="properties[Initials]"]'); if (ini && ini.value) props.Initials = ini.value;
    var items = [{ id: id, quantity: q, properties: props }];
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      giftsFor(q).forEach(function (gid) { if (!c.items.some(function (i) { return i.variant_id === gid; })) items.push({ id: gid, quantity: 1 }); });
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) });
    }).then(function (r) { return r.json(); }).then(function (j) {
      if (j && j.status && j.description) alert(j.description);
      return openCart(true);
    }).catch(function () {}).then(function () { if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); } });
  }, true);

  /* ---------- carrito lateral ---------- */
  var drawer, tEnd = 0;
  function el() { return drawer || (drawer = $('#gg-cart')); }
  function render() {
    return fetch(window.location.pathname + '?sections=gg-cart-drawer', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) {
      var d = new DOMParser().parseFromString(j['gg-cart-drawer'], 'text/html');
      var src = d.querySelector('.ggc'), dst = el().querySelector('.ggc'); if (src && dst) dst.replaceWith(src);
      var n = +(src && src.getAttribute('data-count')) || 0;
      $$('.gg-cart-count').forEach(function (b) { b.textContent = n; b.hidden = !n; });
      return syncGifts();
    });
  }
  function openCart(reset) {
    if (reset) tEnd = Date.now() + 600000;
    return render().then(function () { el().classList.add('is-open'); document.documentElement.classList.add('ggc-lock'); });
  }
  function closeCart() { el().classList.remove('is-open'); document.documentElement.classList.remove('ggc-lock'); }
  function change(key, q) { return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: q }) }).then(function () { tEnd = Date.now() + 600000; return render(); }); }
  /* regalos según nº de guantes y toalla gratis desde $150 (como la ref) */
  var syncing = false;
  function syncGifts() {
    if (syncing) return Promise.resolve(); syncing = true;
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var q = 0; c.items.forEach(function (i) { if (i.product_id === D.product) q += i.quantity; });
      var want = giftsFor(q), g = D.gifts || {}, upd = {}, any = false;
      [g.ship, g.guide, g.card].forEach(function (gid) {
        if (!gid) return; var has = c.items.filter(function (i) { return i.variant_id === gid; }).reduce(function (a, i) { return a + i.quantity; }, 0);
        var w = want.indexOf(gid) > -1 ? 1 : 0; if (has !== w) { upd[gid] = w; any = true; }
      });
      if (!any) return;
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: upd }) }).then(function () {
        return fetch(window.location.pathname + '?sections=gg-cart-drawer').then(function (r) { return r.json(); }).then(function (j) {
          var d = new DOMParser().parseFromString(j['gg-cart-drawer'], 'text/html'); var src = d.querySelector('.ggc'), dst = el().querySelector('.ggc'); if (src && dst) dst.replaceWith(src);
        });
      });
    }).catch(function () {}).then(function () { syncing = false; });
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('#cart-icon-bubble') || t.closest('a[href="/cart"]')) { e.preventDefault(); openCart(false); return; }
    if (!el() || !el().contains(t)) return;
    if (t.closest('[data-ggc-close]') || t.classList.contains('gg-cart__overlay')) { closeCart(); return; }
    var q = t.closest('[data-ggc-q]'); if (q) { var it = q.closest('.ggc__item'); change(it.getAttribute('data-key'), +q.getAttribute('data-ggc-q')); return; }
    if (t.closest('[data-ggc-add-towel]')) { var v = el().querySelector('[data-ggc-towel]').value; fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: +v, quantity: 1 }] }) }).then(function () { return render(); }); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && el() && el().classList.contains('is-open')) closeCart(); });
  setInterval(function () {
    var b = el() && el().querySelector('[data-ggc-timer]'); if (!b) return;
    if (!tEnd) tEnd = Date.now() + 600000; var s = Math.max(0, Math.round((tEnd - Date.now()) / 1000));
    b.textContent = (s / 60 | 0 < 10 ? '0' : '') + (s / 60 | 0) + ':' + (s % 60 < 10 ? '0' : '') + s % 60;
  }, 1000);

  document.addEventListener('DOMContentLoaded', function () { initBars(); cleanKaching(); });
  if (document.readyState !== 'loading') { initBars(); cleanKaching(); }
})();
